import classNames from 'classnames/bind';
import React from 'react';
import { object, string } from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { useImpression } from '@thd-olt-component-react/impression';

import {
  params,
  customType,
  fragment,
  shape as shapeType,
  string as stringType,
  bool as boolType,
  useDataModel, QueryProvider, extend
} from '@thd-nucleus/data-sources';
import styles from '../SponsoredBanner/SponsoredBanner.module.scss';
import { determineDefaultBanner, shouldSkipDataModel } from '../../utils/helpers';

const DefaultBannerComponent = ({ experienceContext, pageSpecificContentfulDefaultBanner, schema }) => {
  let cx = classNames.bind(styles);
  const configServiceDefaultBannerInfo = useConfigService('fs-prop:sponsored-default-banners');
  const skip = shouldSkipDataModel(schema);
  const siteWideContentfulDefaulBannerInfo = useDataModel('container', {
    skip,
    variables: {
      context: {
        id: '4OH5iatZ0vFnTL58Qg8eJv'
      }
    }
  });
  const defaultBannerInfo = determineDefaultBanner({ experienceContext, pageSpecificContentfulDefaultBanner, configServiceDefaultBannerInfo, siteWideContentfulDefaulBannerInfo });

  const { ref, clickID } = useImpression({
    data: {
      id: '00DEFVALSPB00',
      name: 'defaultbanner',
      component: 'SponsoredUniversalBanner',
      type: 'content',
      position: 1,
    }
  });
  return (
    <div
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
      id="default_banner_carousel"
      style={defaultBannerInfo.spacingCss}
      data-testid="default-standard-banner"
    >
      <a href={defaultBannerInfo.href}>
        {/* eslint-disable-next-line */}
        <img
          className={cx('sponsored_banner_image')}
          alt="sponsored banner"
          src={defaultBannerInfo.imgSrc}
        />
      </a>
    </div>
  );
};

const propTypes = {
  experienceContext: object,
  pageSpecificContentfulDefaultBanner: object,
  schema: string
};

const defaultProps = {
  experienceContext: {},
  pageSpecificContentfulDefaultBanner: {},
  schema: ''
};

DefaultBannerComponent.propTypes = propTypes;
DefaultBannerComponent.defaultProps = defaultProps;
DefaultBannerComponent.dataModel = {
  container: params({
    context: customType('QueryContext')
      .shape({
        id: stringType()
      })
  })
    .shape({
      SponsoredTopBanner: fragment()
        .shape({
          imgDesktop: stringType(),
          imgMobile: stringType(),
          clickthruUrl: stringType(),
          specialDefaultBanner: shapeType({
            imgDesktop: stringType(),
            imgMobile: stringType(),
            clickthruUrl: stringType(),
            useSpecialBanner: boolType()
          })
        }),
    }),
};

const DefaultBanner = (props) => {

  const skipFn = ({ skip, queryName }) => {
    return skip;
  };

  return (
    <QueryProvider cacheKey="default-banner" skip={skipFn}>
      <DefaultBannerComponent {...props} />
    </QueryProvider>
  );
};
DefaultBanner.propTypes = propTypes;

DefaultBanner.defaultProps = defaultProps;
DefaultBanner.dataModel = extend({}, DefaultBannerComponent);

export { DefaultBanner };
